import APIService from "@/services/APIService";

const customAgencyPayRatesApi = () => ({
  getGroupedCustomerAgencyFee: ({ bookingId }) =>
    APIService.client().get(
      `custom-agency-pay-rates/view?filter[booking_id]=${bookingId}`
    ),
  editCustomAgencyFee: data =>
    APIService.client().put("custom-agency-pay-rates/update", {
      data
    }),
  getCustomAgencyFees: ({ bookingId }) =>
    APIService.client().get(
      `custom-agency-pay-rates/form?filter[booking_id]=${bookingId}`
    )
});

export default customAgencyPayRatesApi;
